import React, { FC } from 'react';
import { MaterialDTO, MaterialType } from 'src/common/models/material';
import { useDownloadCourseMaterialMutation } from 'src/common/hooks/courseMaterials/useDownloadCourseMaterialMutation';
import DownloadIcon from 'src/assets/icons/DownloadIcon';
import styled, { css } from 'styled-components';
import { CleanButton } from './Button';
import { useIsLoggedIn } from 'src/common/hooks/useIsLoggedIn';
import { colors } from 'src/config/colors';

export const materialDownloadCss = css`
  width: fit-content;
  display: flex;
  gap: 0.625rem;
  white-space: normal;
  text-align: left;

  & > svg {
    flex-shrink: 0;
  }
`;

const MaterialDownloadLink = styled(CleanButton)<{ $available: boolean }>`
  ${materialDownloadCss}
  &:hover {
    text-decoration: underline;
  }

  ${({ $available }) =>
    !$available &&
    css`
      cursor: not-allowed !important;

      * {
        color: ${colors.blue05};
      }

      &:hover {
        text-decoration: none;
      }
    `}
`;

export interface MaterialDownloadProps {
  material: MaterialDTO;
  isUserEnrolled?: boolean;
}

export const MaterialDownload: FC<MaterialDownloadProps> = ({
  material,
  isUserEnrolled = true,
}) => {
  const { isLoggedIn } = useIsLoggedIn();
  const downloadMutation = useDownloadCourseMaterialMutation();

  if (material.type === MaterialType.Url) {
    return (
      <MaterialDownloadLink
        as="a"
        href={material?.url}
        rel="noopener"
        target="_blank"
        $available={isLoggedIn && isUserEnrolled}
      >
        <DownloadIcon size={16} />
        <span>{material.name}</span>
      </MaterialDownloadLink>
    );
  }

  return (
    <MaterialDownloadLink
      onClick={() =>
        downloadMutation.mutate([
          {
            id: material.id,
            filename: material.name ?? material.id.toString(),
          },
        ])
      }
      $available={isLoggedIn && isUserEnrolled}
    >
      <DownloadIcon size={16} />
      <span>{material.name}</span>
    </MaterialDownloadLink>
  );
};
